export const SET_LAST_AD_DATE = 'SET_LAST_AD_DATE';

export const setLastAdDate = adDate => ({
  type: SET_LAST_AD_DATE,
  adDate: adDate
});
